import type { ApiInvite, ApiInviteHook } from '#/api/invite/types/ApiInvite';
import { Indicator } from '#/components/Indicator/Indicator';
import { useI18n } from '#/i18n/hooks/useI18n';

type Props = {
  invite: ApiInvite;
  hook: ApiInviteHook;
};

export function InviteMessage({ invite, hook }: Props) {
  const { i18n } = useI18n();

  switch (hook.hookType) {
    case 'PROMOTE_TO_CONTACT':
      return (
        <Indicator variant="info">
          {i18n(
            '%(inviter)s has added you as a contact to {{strong}}%(name)s{{/strong}}.',
            {
              inviter: invite.byUser.name,
              name: hook.organization?.name ?? '',
              strong: <strong />,
            },
          )}
        </Indicator>
      );
    case 'PROMOTE_TO_ADMIN':
      return (
        <Indicator variant="info">
          {i18n(
            '%(inviter)s has invited you to become an administrator of {{strong}}%(name)s{{/strong}}.',
            {
              inviter: invite.byUser.name,
              name: hook.organization?.name ?? '',
              strong: <strong />,
            },
          )}
        </Indicator>
      );

    case 'PROMOTE_TO_OWNER':
      return (
        <Indicator variant="info">
          {i18n(
            '%(inviter)s has invited you to become an owner of {{strong}}%(name)s{{/strong}}.',
            {
              inviter: invite.byUser.name,
              name: hook.organization?.name ?? '',
              strong: <strong />,
            },
          )}
        </Indicator>
      );

    default:
      throw new Error('invalid hook type');
  }
}
